import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card } from "../../design-system";
import { Icon } from "../../design-system";
import logoWordmark from "../../design-system/assets/kronaly-dark.png";
import { getLoggedinUser } from "../../helpers/api_helper";

const FEATURES = [
  {
    icon: "Calendar",
    title: "Gestión de turnos",
    text: "Organiza los horarios de tu equipo de forma visual. Asigna turnos, gestiona cambios y comunica la planificación al instante.",
  },
  {
    icon: "Clock",
    title: "Control horario",
    text: "Cumple con la normativa de registro de jornada. Fichajes sencillos desde móvil o web con geolocalización opcional.",
  },
  {
    icon: "Plane",
    title: "Vacaciones y ausencias",
    text: "Solicita y aprueba vacaciones, bajas y permisos. Visualiza el calendario del equipo y evita choques.",
  },
  {
    icon: "FileText",
    title: "Contratos y documentos",
    text: "Centraliza los contratos del equipo, anexa terms versionados y mantiene auditoría completa.",
  },
  {
    icon: "TrendingUp",
    title: "Reportes",
    text: "Cumplimiento mensual, horas extra, vacaciones disponibles. Exporta para tu nómina.",
  },
  {
    icon: "ShieldCheck",
    title: "Multi-empresa",
    text: "Una cuenta por persona, varios workspaces si los necesitas. Roles diferenciados por workspace.",
  },
];

const Home = () => {
  document.title = "Kronaly — fichaje y gestión de equipos";
  const [hasSession, setHasSession] = useState(false);

  useEffect(() => {
    setHasSession(!!getLoggedinUser()?.access_token);
  }, []);

  return (
    <div style={{ background: "var(--kr-bg-app)", minHeight: "100vh" }}>
      {/* Top bar pública */}
      <header
        style={{
          height: 64,
          background: "var(--kr-bg-surface)",
          borderBottom: "1px solid var(--kr-border)",
          display: "flex",
          alignItems: "center",
          padding: "0 24px",
          gap: 12,
        }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          <img src={logoWordmark} alt="Kronaly" style={{ height: 22 }} />
        </Link>
        <div style={{ flex: 1 }} />
        {hasSession ? (
          <Button as={Link} variant="primary" size="md" iconRight="ArrowRight" onClick={() => (window.location.href = "/dashboard")}>
            Ir al panel
          </Button>
        ) : (
          <>
            <Link to="/login" style={{ textDecoration: "none", color: "var(--kr-fg-strong)", fontSize: 13, fontWeight: 600, marginRight: 12 }}>
              Iniciar sesión
            </Link>
            <Button variant="primary" size="md" onClick={() => (window.location.href = "/register")}>
              Crear cuenta
            </Button>
          </>
        )}
      </header>

      {/* Hero */}
      <section
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "80px 24px 48px",
          textAlign: "center",
        }}
      >
        <span
          style={{
            display: "inline-block",
            padding: "4px 10px",
            borderRadius: 999,
            background: "var(--kr-action-soft-bg)",
            color: "var(--kr-action-soft-fg)",
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            marginBottom: 16,
          }}
        >
          Plataforma de fichaje y RRHH
        </span>
        <h1
          className="kr-display"
          style={{
            margin: 0,
            fontSize: 48,
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
          }}
        >
          La forma sencilla de gestionar el tiempo de tu equipo
        </h1>
        <p
          style={{
            margin: "16px auto 0",
            maxWidth: 640,
            fontSize: 16,
            color: "var(--kr-fg-muted)",
            lineHeight: 1.6,
          }}
        >
          Fichaje horario, gestión de ausencias, contratos y reportes — en una plataforma calmada,
          rápida y diseñada para empresas que quieren operar con claridad.
        </p>
        <div className="kr-flex kr-justify-center kr-gap-3 kr-mt-5">
          {hasSession ? (
            <Button variant="primary" size="lg" iconRight="ArrowRight" onClick={() => (window.location.href = "/dashboard")}>
              Ir al panel
            </Button>
          ) : (
            <>
              <Button variant="primary" size="lg" onClick={() => (window.location.href = "/register")}>
                Empezar gratis
              </Button>
              <Button variant="secondary" size="lg" onClick={() => (window.location.href = "/login")}>
                Iniciar sesión
              </Button>
            </>
          )}
        </div>
      </section>

      {/* Features */}
      <section style={{ maxWidth: 1080, margin: "0 auto", padding: "32px 24px 80px" }}>
        <div
          className="kr-grid kr-gap-4"
          style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
        >
          {FEATURES.map((f) => (
            <Card key={f.title}>
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  background: "var(--kr-action-soft-bg)",
                  color: "var(--kr-action-soft-fg)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 14,
                }}
              >
                <Icon name={f.icon} size={20} />
              </div>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "var(--kr-fg-strong)" }}>
                {f.title}
              </h3>
              <p style={{ margin: "8px 0 0", color: "var(--kr-fg-muted)", fontSize: 13, lineHeight: 1.5 }}>
                {f.text}
              </p>
            </Card>
          ))}
        </div>
      </section>

      <footer
        style={{
          padding: "24px",
          textAlign: "center",
          borderTop: "1px solid var(--kr-border)",
          background: "var(--kr-bg-surface)",
        }}
      >
        <p style={{ margin: 0, fontSize: 12, color: "var(--kr-fg-muted)" }}>
          © {new Date().getFullYear()} Kronaly
        </p>
      </footer>
    </div>
  );
};

export default Home;
